// extracted by mini-css-extract-plugin
export default {"form":"styles_form__2SAeq","btn":"styles_btn__49evc"};